import React, { useState } from 'react';
import { Box, Typography, Button, Paper } from '@material-ui/core';
import { useDataProvider, useTranslate, } from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import FileItem from '../../file-management/file-item';
import { getFileSizeStr } from '../../utils';
import icDownload from '../../assets/icons/download.png';
import BlockPage from '../../common/block-page';
import TextButton from '../../CustomizedUIs/TextButton';

const useStyles = makeStyles(theme => ({
    list: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        overflow: 'auto'
    },
    inputContainer: {
        height: 150,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(3),
    },
    inputImage: {
        width: 125,
        height: 125,
        border: 'dashed 2px #c1e5fa',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    },
    inputImageIcon: {
        width: 54
    },
    dropFile: {
        position: 'absolute',
        bottom: -theme.spacing(2),
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: 5,
        width: 134,
        boxShadow: '0 0 10px 0 rgba(27, 102, 157, 0.2)'
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        opacity: 0,
    },
    dropFileText: {
        fontFamily: "UniviaPro",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.11px",
        color: "#000000",
    },
    chooseFolderText: {
        fontFamily: "UniviaPro",
        fontSize: "10px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.1px",
        color: " #56657f",
        textDecoration: 'underline'
    },
    btnCreate: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "11px",
        fontWeight: 'bold',
        fontStretch: "normal",
        fontStyle: 'normal',
        lineHeight: "normal",
        letterSpacing: " 0.44px",
        color: "#ffffff",
        padding: '12px 29px'

    },
 
}));

function hasErrorFile(files) {
    return files.findIndex(item => item.error) > -1;
}

function UploadFilesPopup({ close, parentId, onUploadFilesSuccess, acttachmentStyle }) {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [files, setFiles] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const classes = useStyles();

    const onSubmit = (e) => {
        e.preventDefault();
        if (checkFileNameExist()) {
            return;
        }
        setSubmitting(true);

        // Start displaying loading on files
        const newFiles = files.map((item, index) => ({
            ...item,
            id: index,
            loading: true
        }));
        setFiles(newFiles);

        // Check file name exist
        dataProvider('CREATE', 'category/check-file-name', {
            data: {
                id: parentId,
                files: newFiles
            }
        }).then(({ data }) => {
            data.forEach((isNameExist, index) => {
                newFiles[index].error = isNameExist;
            });

            if (hasErrorFile(newFiles)) {
                // Stop uploading and show error file
                newFiles.forEach(item => item.loading = false);
                setFiles(newFiles);
                setSubmitting(false);
                return;
            } else {
                // Only upload when all files not error
                let cloneFiles = newFiles.map(item => item);
                const categories = [];
                newFiles.forEach((file) => {
                    // Only upload not error file
                    const formData = new FormData();
                    formData.append('name', file.name);
                    formData.append('override', file.override);
                    formData.append('file', file.file);

                    dataProvider('UPLOAD', `file/${parentId}/upload`, formData).then(response => {
                        // Remove file
                        cloneFiles = cloneFiles.filter(item => item.id !== file.id);
                        setFiles(cloneFiles);
                        categories.push(response.data);

                        if (cloneFiles.length === 0) {
                            setSubmitting(false);
                            onUploadFilesSuccess(categories);
                        }
                    }).catch(error => {
                        console.error('Upload file error:', error);
                        file.error = true;
                    });
                });
            }
        }).catch(error => {
            console.error('category/check-file-name error:', error);
        });
    }

    const checkFileNameExist = () => {
        let hasError = false;
        const newFiles = files.map(item => item);
        for (let i = 1; i < newFiles.length; i++) {
            for (let j = 0; j < i; j++) {
                if (newFiles[i].name === newFiles[j].name) {
                    newFiles[i].error = true;
                    hasError = true;
                    break;
                }
            }

        }
        setFiles(newFiles);
        return hasError;
    }

    const onChange = event => {
        const { webkitEntries } = event.target;
        const newFiles = [];
        event.target.files.forEach((file, index) => {
            if (webkitEntries.length !== 0 && webkitEntries[index].isDirectory) return;
            const newFile = {
                name: file.name,
                size: getFileSizeStr(file.size),
                file: file,
                error: false,
                loading: false,
                override: false,
                type:file.type
            };
            if(!newFile.type.includes('audio'))
            {
                return ;
            }
            newFiles.push(newFile);
        });
        setFiles([...files, ...newFiles]);
        event.target.value = null;
    }

    const onDelete = index => {
        const newFiles = files.filter((_, idx) => idx !== index);
        setFiles(newFiles);
    }

    const onRename = (index, name) => {
        const newFiles = files.map((file, idx) => (idx === index ? { ...file, name, error: false } : file));
        setFiles(newFiles);
    }

    const onOverrideFile = (index) => {
        const newFiles = files.map((item, idx) => {
            if (index === idx) {
                return {
                    ...item,
                    error: false,
                    override: true
                };
            } else {
                return item;
            }
        })
        setFiles(newFiles);
    }

    return (
        <Paper style={{ padding: 8, width: 228, display: 'flex', justifyContent: 'center' }}>
            <Box width={210} onSubmit={onSubmit} component='form' style={{
                maxHeight: acttachmentStyle ? acttachmentStyle.maxHeight : 'unset',
                overflow: acttachmentStyle ? acttachmentStyle.overflow : 'unset',
                width: '100%'
            }}>
                <BlockPage open={submitting} />
                <Box className={classes.inputContainer}>
                    <Box className={classes.inputImage}>
                        <img alt='' src={icDownload} className={classes.inputImageIcon} />
                        <Box p={1} className={classes.dropFile}>
                            <Typography className={classes.dropFileText}>{translate('pos.categories.DropFile')}</Typography>
                            <Typography className={classes.chooseFolderText}>{translate('pos.categories.chooseFolder')}</Typography>
                        </Box>
                    </Box>
                    <input type='file' accept='audio/*' multiple onChange={onChange} className={classes.input} />
                </Box>
                <Box className={classes.list} style={{ maxHeight: acttachmentStyle ? 'unset' : 220 }}>
                    {
                        files.map((file, index) =>
                            <FileItem
                                file={file}
                                key={index + ''}
                                onDelete={() => onDelete(index)}
                                onRename={(name) => onRename(index, name)}
                                onOverrideFile={() => onOverrideFile(index)}
                                index={index}
                            />
                        )
                    }
                </Box>
                {
                    !submitting && files.length > 0 && (
                        <Box my={1} display='flex' justifyContent='flex-end'>
                            <TextButton size='large'  color='primary' type='button' style={{ marginRight: '1rem' }} onClick={close}/>
                            <Button size='large' className={classes.btnCreate} variant='contained' color='primary' disabled={hasErrorFile(files)} type='submit'>{translate('pos.categories.uploadFiles.upload')}</Button>
                        </Box>
                    )
                }
            </Box>
        </Paper>
    );
}

UploadFilesPopup.propTypes = {
    parentId: PropTypes.number,
    close: PropTypes.func.isRequired,
    onUploadFilesSuccess: PropTypes.func.isRequired,
};

export default UploadFilesPopup;
